export const getHumanReadableDateTime = time => {
    let date = new Date(parseFloat(time));
    let day = date.getDate();
    let month = getMonth(date.getMonth());
    let year = date.getFullYear();
    let hours = date.getHours() === 12 ? 12 : date.getHours() % 12;
    let minutes = date.getMinutes();
    let am = date.getHours() >= 12 ? 'PM' : 'AM';
    let localDate = formatNumber(day) + " " + month + " " + formatNumber(year) + " | " + formatNumber(hours) + ":" + formatNumber(minutes) + " " + am;
    return localDate;
}

export const getHumanReadableDate = time => {
    let date = new Date(parseFloat(time));
    let day = date.getDate();
    let month = getMonth(date.getMonth());
    let year = date.getFullYear();
    let localDate = formatNumber(day) + " " + month + " " + formatNumber(year);
    return localDate;
}

export const getShortDate = time => {
    let date = new Date(parseFloat(time));
    let day = date.getDate();
    let month = date.getMonth();
    let localDate = formatNumber(day) + "/" + formatNumber(month + 1);
    return localDate;
}

export const getHumanReadableTime = time => {
    let date = new Date(parseFloat(time));
    let hours = date.getHours() === 12 ? 12 : date.getHours() % 12;
    let minutes = date.getMinutes();
    let am = date.getHours() >= 12 ? 'PM' : 'AM';
    let localDate = formatNumber(hours) + ":" + formatNumber(minutes) + " " + am;
    return localDate;
}

const getMonth = index => {
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    return months[index];
}

export const getTestTimer = time => {
    let date = new Date(time);
    let utc_date = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    let new_date = new Date(utc_date);

    let seconds = (new_date.getTime() / 1000);
    let hours = Math.floor(seconds / (60 * 60));
    let mins = Math.floor((seconds / 60) % 60);
    let secs = Math.floor(seconds % 60);

    return formatNumber(hours) + ":" + formatNumber(mins) + ":" + formatNumber(secs);
}

export const getRuptureTime = time => {
    if (time === 0) {
        return "--";
    }

    let date = new Date(time);
    let utc_date = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    let new_date = new Date(utc_date);

    let hours = new_date.getHours() === 12 ? 12 : new_date.getHours() > 12 ? new_date.getHours() % 12 : new_date.getHours();
    let mins = new_date.getMinutes();
    let a = new_date.getHours() > 11 ? " PM" : " AM";

    return formatNumber(hours) + ":" + formatNumber(mins) + a;
}

export const msToHMS = ms => {
    let seconds = Math.floor(ms / 1000);
    let hours = Math.floor(seconds / 3600);
    let mins = Math.floor((seconds / 60) % 60);
    let secs = Math.floor(seconds % 60);
    return formatNumber(hours) + ":" + formatNumber(mins) + ":" + formatNumber(secs);
}

export const getFeedbackWindowMs = (feedbackWindowMinutes = 5) => {
    const m = Math.max(2, Math.min(20, Number(feedbackWindowMinutes) || 5));
    return m * 60 * 1000;
};

export const formatCountdownMs = (ms) => {
    const sec = Math.max(0, Math.ceil(Math.max(0, Number(ms) || 0) / 1000));
    const m = Math.floor(sec / 60);
    const r = sec % 60;
    return `${m}:${String(r).padStart(2, '0')}`;
};

export const formatFeedbackCountdownFromDeadline = (endMs, nowMs = Date.now()) => {
    const ms = Math.max(0, Number(endMs) - nowMs);
    const sec = Math.max(0, Math.ceil(ms / 1000));
    const m = Math.floor(sec / 60);
    const r = sec % 60;
    return `${m}:${String(r).padStart(2, '0')}`;
};

const formatNumber = n => {
    return n > 9 ? "" + n : "0" + n;
}